import React from "react";
import { useWatch } from "react-hook-form";
import Grid from "@mui/material/Grid";
import CommonFields from "components/CommonFields";
import { INPUT_TYPE } from "globalConstants";
import { useUploadFile } from "hooks";
import generateTestId from "utils/generateTestId";
import LoanAccountCreditItem from "./LoanAccountAdditionalItem";

const LoanAccountAdditional = ({ prefix, setCurrentInput, index, pane }: { prefix: string; setCurrentInput: any; index: number; pane?: string }) => {
    const firstLoan = useWatch({ name: `${prefix}.loanAccountAdditional.0` });

    return (
        <Grid container direction="row" justifyContent="flex-start" alignItems="center">
            <LoanAccountCreditItem index={index} prefix={prefix} setCurrentInput={setCurrentInput} pane={pane} />
            {index === 0 && (
                <CommonFields
                    inputType={INPUT_TYPE.FILE}
                    label="Emi Receipt"
                    data-testid={generateTestId(`emi-reciept-loan-account-additional-${index + 1}-${pane}`, "field")}
                    readOnly={localStorage.getItem("disable_form") === "true"}
                    name={`${prefix}.loanAccountAdditional.0.emiReceipt`}
                    multiple={true}
                    prop={{
                        value: "Entire Loan Period",
                    }}
                    handleChange={useUploadFile({
                        name: "emiReceipt",
                        fileAddress: `${prefix}.loanAccountAdditional.0.emiReceipt`,
                        multiple: true,
                    })}
                    value={firstLoan?.emiReceipt}
                    showCross={localStorage.getItem("disable_form") !== "true" && firstLoan?.emiReceipt && firstLoan?.emiReceipt?.[0]?.link !== ""}
                    handleFileModalOpen={({ position }) => {
                        setCurrentInput({ name: `${prefix}.loanAccountAdditional.0.emiReceipt`, open: true, position: position, multiple: true });
                    }}
                />
            )}
        </Grid>
    );
};

export default LoanAccountAdditional;
